// Note, characters need to be declared uppercase eg ctrl+shift+N

const config = [
	{
		win: 'ctrl+altLeft+0',
		mac: 'meta+alt+0',
		context: 'tinymce.block',
		param: 'FormatBlock-p',
		description: 'Paragraph',
	},
	{
		win: 'ctrl+altLeft+1',
		mac: 'meta+alt+1',
		context: 'tinymce.block',
		param: 'FormatBlock-h1',
		description: 'Heading 1',
	},
	{
		win: 'ctrl+altLeft+2',
		mac: 'meta+alt+2',
		context: 'tinymce.block',
		param: 'FormatBlock-h2',
		description: 'Heading 2',
	},
	{
		win: 'ctrl+altLeft+3',
		mac: 'meta+alt+3',
		context: 'tinymce.block',
		param: 'FormatBlock-h3',
		description: 'Heading 3',
	},
	{
		win: 'ctrl+altLeft+4',
		mac: 'meta+alt+4',
		context: 'tinymce.block',
		param: 'FormatBlock-h4',
		description: 'Heading 4',
	},
	{
		win: 'ctrl+altLeft+5',
		mac: 'meta+alt+5',
		context: 'tinymce.block',
		param: 'FormatBlock-h5',
		description: 'Heading 5',
	},
	{
		win: 'ctrl+altLeft+6',
		mac: 'meta+alt+6',
		context: 'tinymce.block',
		param: 'FormatBlock-h6',
		description: 'Heading 6',
	},
	{
		win: 'ctrl+shift+7',
		mac: 'meta+shift+7',
		context: 'tinymce.list',
		param: 'InsertOrderedList',
		description: 'Numbered List',
	},
	{
		win: 'ctrl+shift+8',
		mac: 'meta+shift+8',
		context: 'tinymce.block',
		param: 'InsertUnorderedList',
		description: 'Bullet List',
	},
	{
		win: 'ctrl+altLeft+9',
		mac: 'ctrl+altLeft+9',
		context: 'tinymce.quote',
		param: 'mceBlockQuote',
		description: 'Quote',
	},
	{
		win: 'ctrl+shift+I',
		mac: 'meta+shift+I',
		context: '',
		param: 'confDefaultTable',
		description: 'Insert Table',
	},
	{
		win: 'ctrl+shift+M',
		mac: 'meta+shift+M',
		context: '',
		param: 'confMonospace',
		description: 'Mono Spaced Font',
	},
	{
		win: 'ctrl+shift+-',
		mac: 'meta+shift+-',
		context: '',
		param: 'InsertHorizontalRule',
		description: 'Insert Horizontal Rule',
	},
	{
		win: 'ctrl+H',
		mac: 'meta+shift+H',
		context: '',
		param: 'mceSearchReplaceToolbar',
		description: 'Find Replace',
	},
	{
		win: 'ctrl+\\',
		mac: 'meta+\\',
		context: '',
		param: 'RemoveFormat',
		description: 'Remove Formatting',
	},
	{
		win: 'ctrl+/',
		mac: 'meta+/',
		context: '',
		param: 'mceConfShortcutDialog',
		description: 'Help',
	},
	{
		win: 'alt+shift+arrowUp',
		mac: 'ctrl+alt+arrowUp',
		context: '',
		param: 'mceTableInsertRowBefore',
		description: 'Insert table row above',
	},
	{
		win: 'alt+shift+arrowDown',
		mac: 'ctrl+alt+arrowDown',
		context: '',
		param: 'mceTableInsertRowAfter',
		description: 'Insert table row after',
	},
	{
		win: 'alt+shift+arrowRight',
		mac: 'ctrl+alt+arrowRight',
		context: '',
		param: 'mceTableInsertColAfter',
		description: 'Insert column after',
	},
	{
		win: 'alt+shift+arrowLeft',
		mac: 'ctrl+alt+arrowLeft',
		context: '',
		param: 'mceTableInsertColBefore',
		description: 'Insert column before',
	},
	{
		win: 'ctrl+shift+9',
		mac: 'meta+shift+9',
		context: '',
		param: 'FormatBlock-blockquote',
		description: 'Quote',
	},
	{
		win: 'ctrl+S',
		mac: 'meta+S',
		context: 'form.input',
		param: 'preventDefaultSave',
		description: 'Prevent default behavior of browser',
	},
	{
		win: 'ctrl+13',
		mac: 'meta+13',
		context: 'form.input',
		param: 'publish',
		description: 'Save',
	},
	{
		win: 'ctrl+shift+E',
		mac: 'meta+shift+E',
		context: 'form.input',
		param: 'preview',
		description: 'Preview',
	},
	{
		win: 'ctrl+shift+J',
		mac: 'meta+shift+J',
		context: '',
		param: 'mceJiralink',
		description: 'Open Insert JIRA dialog',
	},
];

export default config;
